import Vue from "vue";
import Router from "vue-router";

import auditList from "@/components/auditList";
import newSocialInsureList from "@/components/newSocialInsureList";
import otherFeeList from "@/components/otherFeeList";
import salaryDetail from "@/components/salaryDetail";
import salaryDetailList from "@/components/salaryDetailList";
import salaryLabelList from "@/components/salaryLabelList";
import salarySummary from "@/components/salarySummary";
import serviceItemsP from "@/components/serviceAbility/serviceItemsP";
// wms
import stationList from "@/components/stationList";
import attrManage from "@/components/wms/attrManage";
import brandList from "@/components/wms/brandList";
import categoryManage from "@/components/wms/categoryManage";
import checkStockReceipt from "@/components/wms/checkStockReceipt";
import handleShipment from "@/components/wms/handleShipment";
import leaseInfo from "@/components/wms/leaseInfo";
import myWarehouse from "@/components/wms/myWarehouse";
import productApply from "@/components/wms/productApply";
import productList from "@/components/wms/productList";
import providerList from "@/components/wms/providerList";
import purchaseManage from "@/components/wms/purchaseManage";
import stocklogList from "@/components/wms/stocklogList";
import stockReport from "@/components/wms/stockReport";
import warehouseList from "@/components/wms/warehouseList";

import telecomCardOrder from "@/components/wms/telecomCardOrder";
import toolbagConfig from "@/components/wms/toolbagConfig";
import toolbagGrant from "@/components/wms/toolbagGrant";
import wmsOrderCenter from "@/components/wms/wmsOrderCenter";


//crm
import cluePrivate from "@/components/workercrm/cluePrivate";
import cluePublic from "@/components/workercrm/cluePublic";
import myWorker from "@/components/workercrm/myWorker";
import workerList from "@/components/workercrm/workerList";
// import ticketDetail from "@/components/workercrm/ticketDetail";
import clueDetail from "@/components/workercrm/clueDetail";
import servantDetail from "@/components/workercrm/servantDetail";

//合伙人的保洁推荐，收入
import servantIncome from "@/components/workercrm/hhr/servantIncome";
import workerRecommend from "@/components/workercrm/hhr/workerRecommend";

import dormList from "@/components/dorm/dormList";
import dormStaff from "@/components/dorm/dormStaff";
import postStationList from "@/components/postStationList";
import addCourse from "@/components/workercrm/emcourse/addCourse";
import courseArrange from "@/components/workercrm/emcourse/courseArrange";
import courseManager from "@/components/workercrm/emcourse/courseManager";
import labelSkill from "@/components/workercrm/emcourse/labelSkill";
import resourceList from "@/components/workercrm/emcourse/resourceList";
import studentTrain from "@/components/workercrm/emcourse/studentTrain";
import leaveApplication from "@/components/workercrm/leaveApplication";


import userDataLimits from "@/components/workercrm/userDataLimits";
import workerMentor from "@/components/workercrm/workerMentor";

import documentary from "@/components/workercrm/documentary";

import managerBoard from "@/components/workercrm/dashboard/managerBoard";
import stationBoard from "@/components/workercrm/dashboard/stationBoard";

import label from "@/components/workercrm/label/label";
import profile from "@/components/workercrm/label/profile";
import target from "@/components/workercrm/label/target";

import brokerAccount from "@/components/workercrm/brokerAccount";
import contractManager from "@/components/workercrm/contract/contractManager";

import jxOrderList from "@/components/jxworker/jxOrderList";

import ticketEntry from "@/components/category";
import nucleic from "@/components/nucleic";
import pre from "@/components/pre";
import prebj from "@/components/preorder/prebj";

import workerNotice from "@/components/messagelog/workerNotice";
import workerOperLog from "@/components/messagelog/workerOperLog";

import gzhTemplate from "@/components/gzhManage/gzhTemplate";
import gzhTimerTask from "@/components/gzhManage/gzhTimerTask";
import gzhTimerTaskLog from "@/components/gzhManage/gzhTimerTaskLog";

import interviewList from "@/components/task/interviewList";
import myTaskList from "@/components/task/myTaskList";
import taskConfigList from "@/components/task/taskConfigList";
import taskDetail from "@/components/task/taskDetail";
import taskList from "@/components/task/taskList";
import cpMessage from "@/components/workercrm/cp/cpMessage";
import cpTag from "@/components/workercrm/cp/cpTag";
import cpWorker from "@/components/workercrm/cp/cpWorker";

import contractProcedureInfo from "@/components/contract/contractProcedureInfo";
import signatoryList from "@/components/contract/signatoryList";
import templateList from "@/components/contract/templateList";
import jmsContract from "@/components/jmsContract/jmsContract";
import workerManager from "@/components/workercrm/workerManager"; //运营管家


import appleTeam from "@/components/workercrm/appleTeam";
import zzyList from "@/components/workercrm/zzyList";
import zzyPause from "@/components/workercrm/zzyPause";
import zzyShareList from "@/components/workercrm/zzyShareList";
import Login from "../components/page/Login.vue";

Vue.use(Router);

const router = new Router({
  base: '/',
  mode: 'history',  //去掉url中的#
  routes: [{
    path: "/",
    name: 'redirect',
    component: Login
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: "/servantManage",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "服务者管理"
    },
    children: [
      {
        path: 'workEntry',
        component: resolve => require(['../components/ticket/workEntry.vue'], resolve),
        meta: {
          title: '日常工作台'
        },
      },
      {
        path: 'goalConfig',
        component: resolve => require(['../components/ticket/goalConfig.vue'], resolve),
        meta: {
          title: '指标配置'
        },
      }
    ]
  },
  {
    path: "/serviceAbilityConfig",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "服务力配置"
    },
    children: [
      {
        path: 'serviceItemsP',
        name: 'serviceItemsP',
        component: serviceItemsP,
        meta: {
          title: '服务项管理'
        }
      },
      {
        path: 'workerSkill',
        component: resolve => require(['@/components/serviceAbility/workerSkill.vue'], resolve),
        meta: {
          title: '服务者技能'
        }
      },
      {
        path: 'sourceFormP',
        component: resolve => require(['@/components/serviceAbility/sourceFormP.vue'], resolve),
        meta: {
          title: '来源管理'
        }
      },
      {
        path: 'sourceUnitP',
        component: resolve => require(['@/components/serviceAbility/sourceUnitP.vue'], resolve),
        meta: {
          title: '门店管理'
        }
      },
      {
        path: 'teamManagementP',
        component: resolve => require(['@/components/serviceAbility/teamManagementP.vue'], resolve),
        meta: {
          title: '排班设置'
        }
      },
      //班组设置
      {
        path: 'settingSchedulingP',
        component: resolve => require(['@/components/serviceAbility/settingSchedulingP.vue'], resolve),
        meta: {
          title: '班组设置'
        }
      },
      {
        path: 'schedulingP',
        component: resolve => require(['@/components/serviceAbility/schedulingP.vue'], resolve),
        meta: {
          title: '档期管理'
        }
      },
      {
        path: 'schedulingCalendar',
        component: resolve => require(['@/components/serviceAbility/schedulingCalendar.vue'], resolve),
        meta: {
          title: '档期日历'
        }
      },
      {
        path: 'hmDispatchOrderPage',
        component: resolve => require(['@/components/serviceAbility/hmDispatchOrderPage.vue'], resolve),
        meta: {
          title: '盒马假人派单'
        }
      },
      {
        path: 'workerSchReport',
        component: resolve => require(['@/components/serviceAbility/workerSchReport.vue'], resolve),
        meta: {
          title: '接单配置查看'
        }
      },
       {
            path: 'fraRegionAreaConfig',
            component: resolve => require(['@/components/serviceAbility/fraRegionAreaConfig.vue'], resolve),
            meta: {
              title: '接单区域配置'
            }
      },
      {
        path: 'schedulingCalendarHM',
        component: resolve => require(['@/components/serviceAbility/schedulingCalendarHM.vue'], resolve),
        meta: {
          title: '档期日历HM'
        }
      },
    ]
  },
  {
    path: "/salaryManage",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "服务费管理"
    },
    children: [
      {
        path: "salarySummary",
        name: "salarySummary",
        component: salarySummary,
        meta: {
          title: "服务费汇总"
        }
      },
      {
        path: "newSocialInsureList",
        name: "newSocialInsureList",
        component: newSocialInsureList,
        meta: {
          title: "新农保明细"
        }
      },
      {
        path: "salaryDetailList",
        name: "salaryDetailList",
        component: salaryDetailList,
        meta: {
          title: "服务费明细"
        }
      },
      {
        path: "salaryDetail",
        name: "salaryDetail",
        component: salaryDetail,
        meta: {
          title: "服务费详情"
        }
      },
      {
        path: "otherFeeList",
        name: "otherFeeList",
        component: otherFeeList,
        meta: {
          title: "杂费明细"
        }
      },
      {
        path: "auditList",
        name: "auditList",
        component: auditList,
        meta: {
          title: "申诉审批"
        }
      },
      {
        path: "salaryLabelList",
        name: "salaryLabelList",
        component: salaryLabelList,
        meta: {
          title: "服务费标签"
        }
      }
    ]
  },
  {
    path: "/warehouseCenter",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "仓库中心"
    },
    children: [
      {
        path: "orderCenter",
        name: "orderCenter",
        component: wmsOrderCenter,
        meta: {
          title: "订单中心"
        }
      },
      {
        path: "telecomCardOrder",
        name: "telecomCardOrder",
        component: telecomCardOrder,
        meta: {
          title: "电信卡订单"
        }
      },
      {
        path: "leaseInfo",
        name: "leaseInfo",
        component: leaseInfo,
        meta: {
          title: "租赁管理"
        }
      },
      {
        path: "dispatchCenter",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "调度中心"
        },
        children: [
          {
            path: "handleShipment",
            name: "handleShipment",
            component: handleShipment,
            meta: {
              title: "出入库单"
            }
          },
          {
            path: "productApply",
            name: "productApply",
            component: productApply,
            meta: {
              title: "货品申请单"
            }
          },
          {
            path: "purchaseManage",
            name: "purchaseManage",
            component: purchaseManage,
            meta: {
              title: "采购单"
            }
          } 
        ]
      },
      {
        path: "warehouseManage",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "仓库管理"
        },
        children: [
          {
            path: "myWarehouse",
            name: "myWarehouse",
            component: myWarehouse,
            meta: {
              title: "我的仓库"
            }
          },
          {
            path: "checkStockReceipt",
            name: "checkStockReceipt",
            component: checkStockReceipt,
            meta: {
              title: "盘库"
            }
          },
          {
            path: "stocklogList",
            name: "stocklogList",
            component: stocklogList,
            meta: {
              title: "出入库记录"
            }
          },
          {
            path: "stockReport",
            name: "stockReport",
            component: stockReport,
            meta: {
              title: "库存统计"
            }
          }
        ]
      },
      {
        path: "toolbagConfig",
        name: "toolbagConfig",
        component: toolbagConfig,
        meta: {
          title: "工具包配置"
        }
      },
      {
        path: "toolbagGrant",
        name: "toolbagGrant",
        component: toolbagGrant,
        meta: {
          title: "工具包发放"
        }
      },
      {
        path: "warehouseBasic",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "仓库基础信息"
        },
        children: [
          {
            path: "warehouseList",
            name: "warehouseList",
            component: warehouseList,
            meta: {
              title: "仓库列表"
            }
          },
          {
            path: "categoryManage",
            name: "categoryManage",
            component: categoryManage,
            meta: {
              title: "类目管理"
            }
          },
          {
            path: "attrManage",
            name: "attrManage",
            component: attrManage,
            meta: {
              title: "属性管理"
            }
          },
          {
            path: "productList",
            name: "productList",
            component: productList,
            meta: {
              title: "商品信息"
            }
          },
          {
            path: "providerList",
            name: "providerList",
            component: providerList,
            meta: {
              title: "供应商列表"
            }
          },
          {
            path: "brandList",
            name: "brandList",
            component: brandList,
            meta: {
              title: "品牌列表"
            }
          },
        ]
      }
    ]
  },
  {
    path: "/workermanager",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "服务者"
    },
    children: [
      {
        path: "jxHoursEmployee",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "鲸选钟点工"
        },
        children: [
          {
            path: "jxOrderList",
            name: "jxOrderList",
            component: jxOrderList,
            meta: {
              title: "鲸选订单列表"
            }
          }
        ]
      },
      {
        path: "empowermentTrain",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "招商赋能"
        },
        children: [
          {
            path: "cluePublic",
            name: "cluePublic",
            component: cluePublic,
            meta: {
              title: "全量线索"
            }
          },
          {
            path: "clueDetail",
            name: "clueDetail",
            component: clueDetail,
            meta: {
              title: "线索线索详情"
            }
          },
          {
            path: "cluePrivate",
            name: "cluePrivate",
            component: cluePrivate,
            meta: {
              title: "线索私海"
            }
          },
          {
            path: "documentary",
            name: "documentary",
            component: documentary,
            meta: {
              title: "跟单管理"
            }
          },
          {
            path: "courseManager",
            name: "courseManager",
            component: courseManager,
            meta: {
              title: "课程配置"
            }
          },
          {
            path: "resourceList",
            name: "resourceList",
            component: resourceList,
            meta: {
              title: "课程资源"
            }
          },
          {
            path: "addCourse",
            name: "addCourse",
            component: addCourse,
            meta: {
              title: "新增课程"
            }
          },
          {
            path: "courseArrange",
            name: "courseArrange",
            component: courseArrange,
            meta: {
              title: "课程安排"
            }
          },
          {
            path: "studentTrain",
            name: "studentTrain",
            component: studentTrain,
            meta: {
              title: "学员培训"
            }
          },
          {
            path: "labelSkill",
            name: "labelSkill",
            component: labelSkill,
            meta: {
              title: "标签技能"
            }
          },
          {
            path: "interviewList",
            name: "interviewList",
            component: interviewList,
            meta: {
              title: "面试列表"
            }
          },
          {
            path: "myTaskList",
            name: "myTaskList",
            component: myTaskList,
            meta: {
              title: "我的任务"
            }
          },
        ]
      },
      {
        path: "lifeManager",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "保洁服务者"
        },
        children: [
          {
            path: "workerList",
            name: "workerList",
            component: workerList,
            meta: {
              title: "服务者列表"
            }
          },
          {
            path: "servantDetail",
            name: "servantDetail",
            component: servantDetail,
            meta: {
              title: "服务者详情"
            }
          },
          {
            path: "myWorker",
            name: "myWorker",
            component: myWorker,
            meta: {
              title: "我的服务者"
            }
          },
          {
            path: "workerMentor",
            name: "workerMentor",
            component: workerMentor,
            meta: {
              title: "师徒列表"
            }
          },
          {
            path: "dormList",
            name: "dormList",
            component: dormList,
            meta: {
              title: "宿舍列表"
            }
          },
          {
            path: "dormStaff",
            name: "dormStaff",
            component: dormStaff,
            meta: {
              title: "宿舍人员"
            }
          },
          {
            path: "leaveApplication",
            name: "leaveApplication",
            component: leaveApplication,
            meta: {
              title: "请假申请"
            }
          },
          {
            path: "workerManager",
            name: "workerManager",
            component: workerManager,
            meta: {
              title: "商家运营"
            }
          },
          {
            path: "workerPostLeader",
            component: resolve => require(['../components/workercrm/workerPostLeader.vue'], resolve),
            meta: {
              title: "驿站老师"
            }
          },
          {
            path: "zzyShareList",
            name: "zzyShareList",
            component: zzyShareList,
            meta: {
              title: "招招盈分享"
            }
          },
          {
            path: "zzyList",
            name: "zzyList",
            component: zzyList,
            meta: {
              title: "招招盈关系"
            }
          },
          {
            path: "zzyPause",
            name: "zzyPause",
            component: zzyPause,
            meta: {
              title: "招招盈操作记录"
            }
          },
          {
            path: "appleTeam",
            name: "appleTeam",
            component: appleTeam,
            meta: {
              title: "调班申请"
            }
          }
        ]
      },
      {
        path: "labelManager",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "画像指标"
        },
        children: [
          {
            path: "label",
            name: "label",
            component: label,
            meta: {
              title: "标签设置"
            }
          },
          {
            path: "profile",
            name: "profile",
            component: profile,
            meta: {
              title: "服务者画像"
            }
          },
          {
            path: "target",
            name: "target",
            component: target,
            meta: {
              title: "指标设置"
            }
          },
        ]
      },
      {
        path: "dashboard",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "管理看板"
        },
        children: [
          {
            path: "stationBoard",
            name: "stationBoard",
            component: stationBoard,
            meta: {
              title: "站长看板"
            }
          },
          {
            path: "managerBoard",
            name: "managerBoard",
            component: managerBoard,
            meta: {
              title: "管理看板"
            }
          },
        ]
      },
      {
        path: "personRecommend",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "人员推荐"
        },
        children: [
          {
            path: "workerRecommend",
            name: "workerRecommend",
            component: workerRecommend,
            meta: {
              title: "保洁推荐"
            }
          },
          {
            path: "servantIncome",
            name: "servantIncome",
            component: servantIncome,
            meta: {
              title: "保洁收入"
            }
          },
        ]
      },
      {
        path: "contractManager",
        name: "contractManager",
        component: contractManager,
        meta: {
          title: "合同管理"
        }
      },
      {
        path: "nucleic",
        name: "nucleic",
        component: nucleic,
        meta: {
          title: "核酸抗原记录"
        }
      },
      {
        path: "previewing",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "预检单"
        },
        children: [
          {
            path: "ticketEntry",
            name: "ticketEntry",
            component: ticketEntry,
            meta: {
              title: "服务项"
            }
          },
          {
            path: "pre",
            name: "pre",
            component: pre,
            meta: {
              title: "品类预检结果"
            }
          },
          {
            path: "prebj",
            name: "prebj",
            component: prebj,
            meta: {
              title: "保洁预检"
            }
          }
        ]
      }

    ]
  },
  {
    path: "/merchantTicket",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "商家工单"
    },
    children: [
      {
        path: 'ticketList',
        component: resolve => require(['../components/ticket/ticketList.vue'], resolve),
        meta: {
          title: '全部工单'
        },
      },
      {
        path: 'merchantTicketDetail',
        component: resolve => require(['../components/ticket/ticketDetail.vue'], resolve),
        meta: {
          title: '工单详情'
        },
      },
      {
        path: 'myTicket',
        component: resolve => require(['../components/ticket/myTicket.vue'], resolve),
        meta: {
          title: '我的工单'
        },
      },
      {
        path: 'ticketType',
        component: resolve => require(['../components/ticket/ticketType.vue'], resolve),
        meta: {
          title: '工单类型'
        },
      },
      {
        path: 'ticketResult',
        component: resolve => require(['../components/ticket/ticketResult.vue'], resolve),
        meta: {
          title: '处理结果'
        },
      },
      {
        path: 'skillGroup',
        component: resolve => require(['../components/ticket/skillGroup.vue'], resolve),
        meta: {
          title: '技能组管理'
        },
      },
    ]
  },
  {
    path: "/cityandstation",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "城市驿站"
    },
    children: [
      {
        path: 'serviceRegionConfig',
        component: resolve => require(['@/components/serviceAbility/serviceRegionConfig.vue'], resolve),
        meta: {
          title: '区域配置'
        }
      },
      {
        path: 'cityList',
        component: resolve => require(['@/components/cityList.vue'], resolve),
        meta: {
          title: '城市列表'
        }
      },
      {
        path: "stationList",
        name: "stationList",
        component: stationList,
        meta: {
          title: "服务站"
        }
      },
      {
        path: "postStationList",
        name: "postStationList",
        component: postStationList,
        meta: {
          title: "驿站"
        }
      },
      {
        path: "userDataLimits",
        name: "userDataLimits",
        component: userDataLimits,
        meta: {
          title: "数据权限"
        }
      },
      {
        path: "brokerAccount",
        name: "brokerAccount",
        component: brokerAccount,
        meta: {
          title: "管家账号"
        }
      }
    ]
  },
  {
    path: "/messagelog",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "系统日志"
    },
    children: [
      {
        path: "workerOperLog",
        name: "workerOperLog",
        component: workerOperLog,
        meta: {
          title: "服务者系统操作日志"
        }
      }
    ]
  },
  {
    path: "/gzhManage",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "公众号管理"
    },
    children: [
      {
        path: "gzhTemplate",
        name: "gzhTemplate",
        component: gzhTemplate,
        meta: {
          title: "模板配置"
        }
      },
      {
        path: "gzhTimerTask",
        name: "gzhTimerTask",
        component: gzhTimerTask,
        meta: {
          title: "任务配置"
        }
      },
      {
        path: "gzhTimerTaskLog",
        name: "gzhTimerTaskLog",
        component: gzhTimerTaskLog,
        meta: {
          title: "公众号消息"
        }
      },
      {
        path: "workerNotice",
        name: "workerNotice",
        component: workerNotice,
        meta: {
          title: "小程序消息"
        }
      }

    ]
  },
  {
    path: "/cpManage",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "企微管理"
    },
    children: [
      {
        path: "cpTag",
        name: "cpTag",
        component: cpTag,
        meta: {
          title: "企微标签"
        }
      },
      {
        path: "cpWorker",
        name: "cpWorker",
        component: cpWorker,
        meta: {
          title: "企微商家"
        }
      },
      {
        path: "cpMessage",
        name: "cpMessage",
        component: cpMessage,
        meta: {
          title: "企微会话"
        }
      }
    ]
  },
  {
    path: "/exam",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "考试评分"
    },
    children: [
      {
        path: "examType",
        component: resolve => require(['../components/exam/examType.vue'], resolve),
        meta: {
          title: "试题分类"
        }
      },
      {
        path: "examQuestions",
        component: resolve => require(['../components/exam/examQuestions.vue'], resolve),
        meta: {
          title: "试题设置"
        }
      },
      {
        path: "examPaper",
        component: resolve => require(['../components/exam/examPaper.vue'], resolve),
        meta: {
          title: "试卷配置"
        }
      },
      {
        path: "examResult",
        component: resolve => require(['../components/exam/examResult.vue'], resolve),
        meta: {
          title: "考试结果"
        }
      }
    ]
  },
  {
    path: "/taskCenter",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "任务中心"
    },
    children: [
      {
        path: "taskList",
        name: "taskList",
        component: taskList,
        meta: {
          title: "任务列表"
        }
      },
      {
        path: "taskDetail",
        name: "taskDetail",
        component: taskDetail,
        meta: {
          title: "任务详情"
        }
      },
      {
        path: "taskConfigList",
        name: "taskConfigList",
        component: taskConfigList,
        meta: {
          title: "任务配置列表"
        }
      }
    ]
  },
  {
    path: "/jmsContract",
    name: "jmsContract",
    component: jmsContract,
    meta: {
      title: "加盟商合同"
    }
  },
  {
    path: "/contractConfig",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "合同配置"
    },
    children: [
      {
        path: 'templateList',
        component: templateList,
        meta: {
          title: '合同配置列表'
        }
      },// 合同流程信息
      {
        path: 'contractProcedureInfo',
        component: contractProcedureInfo,
        meta: {
          title: '合同流程信息'
        }
      },//签署人信息列表
      {
        path: 'signatoryList',
        component: signatoryList,
        meta: {
          title: '签署人信息列表'
        }
      },
      {
        path: 'templateManage',
        component: resolve => require(['../components/page/electronicContract/templateManage.vue'], resolve),
        meta: {
          title: '服务者加盟商模板'
        },

      }
    ]
  },
  {
    path: "/sysconfig",
    component: () =>
      import("../components/common/Home.vue"),
    meta: {
      title: "系统设置"
    },
    children: [
      {
        path: 'ManageList',
        component: resolve => require(['../components/page/permissionSetting/ManageList.vue'], resolve),
        meta: {
          title: '用户列表'
        }
      },
      {
        path: "role",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "角色"
        },
        children: [
          {
            path: 'organizationTree',
            component: resolve => require(['../components/page/permissionSetting/organizationTree.vue'], resolve),
            meta: {
              title: '组织树'
            }
          },
          {
            path: 'roleList',
            component: resolve => require(['../components/page/permissionSetting/roleList.vue'], resolve),
            meta: {
              title: '角色列表'
            }
          },
          {
            path: 'commonData',
            component: resolve => require(['../components/page/permissionSetting/commonData.vue'], resolve),
            meta: {
              title: '城市列表'
            }
          }
        ]
      },
      {
        path: "franchiseeManager",
        component: () =>
          import("../components/common/Home.vue"),
        meta: {
          title: "合伙人(星海)"
        },
        children: [
          {
            path: 'regionStore',
            component: resolve => require(['../components/page/franchiseeManager/regionStore.vue'], resolve),
            meta: {
              title: '区域列表'
            }
          },
          //合伙人公司
          {
            path: 'fraCompany',
            component: resolve => require(['../components/page/enterpriseManage/fraCompany.vue'], resolve),
            meta: {
              title: '公司管理'
            },
          },


          // 公司下属门店
          {
            path: 'companyStore',
            component: resolve => require(['../components/page/enterpriseManage/companyStore.vue'], resolve),
            meta: {
              title: '门店管理'
            },
          },
          // 公司下属门店
          {
            path: 'accountManage',
            component: resolve => require(['../components/page/enterpriseManage/accountManage.vue'], resolve),
            meta: {
              title: '账号管理'
            },
          }
        ]
      }
    ]
  },

  ]
});


function checkurl(url) {
  let userMenu = JSON.parse(window.localStorage.getItem("menulist")); //菜单list
  let boo = false;
  if (userMenu == undefined) {
    return boo;
  }
  for (let i = 0; i < userMenu.length; i++) {
    let murl = userMenu[i].menuUrl;
    if (url.indexOf(murl) != -1) {
      boo = true;
      break;
    }
  }

  return boo;
}

export default router;
